import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { ChatAnalysisType } from 'src/app/interfaces/chat-analysis/chat-analysis'
import { LocaleCode } from 'src/app/interfaces/locale'
import { LogEvent } from 'src/app/interfaces/log'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { LogService } from 'src/app/services/log/log.service'
import { ModalService } from 'src/app/services/modal/modal.service'
import { RouterService } from 'src/app/services/router/router.service'
import { AlarmAppInstallModalComponent } from '../../modals/alarm-app-install-modal/alarm-app-install-modal.component'
import { UserService } from 'src/app/services/user/user.service'
import { WebInstallChoiceModalComponent } from '../../modals/web-install-choice-modal/web-install-choice-modal.component'
import { LoginInstallChoiceModalComponent } from '../../modals/login-install-choice-modal/login-install-choice-modal.component'

export type RecommendContentType =
  | 'group-chat-analysis'
  | 'situationship-chat-analysis'
  | 'dating-chat-analysis'
  | 'group-chemi'
  | 'mbti-quiz'
  | 'deep-link-daily-log'
  | 'deep-link-cabinet'
  | 'soulmate'
  | 'hsp-quiz'
  | 'saju'
  | 'daily-log'
  | 'egen-teto-quiz'

type RecommendedContent = {
  type: RecommendContentType
  image: string
  moveTo: string
  queryParams?: Record<string, string>
  onlyForApp?: boolean
}

@Component({
  selector: 'recommend-content-horizontal-list',
  templateUrl: './recommend-content-horizontal-list.component.html',
  styleUrls: ['./recommend-content-horizontal-list.component.scss'],
})
export class RecommendContentHorizontalListComponent implements OnInit, OnChanges {
  constructor(
    private modalService: ModalService,
    private routerService: RouterService,
    private logService: LogService,
    private localeService: LocaleService,
    private userService: UserService
  ) {}

  @Input() excludedContents: RecommendContentType[] = []
  isLoggedIn = this.userService.isLoggedIn

  private cardListKo: RecommendedContent[] = [
    {
      type: 'saju',
      image: 'assets/icons/content-banner/saju-dohwa.png',
      moveTo: 'saju',
    },
    {
      type: 'egen-teto-quiz',
      image: 'assets/icons/content-banner/egen-teto-quiz.png',
      moveTo: 'egen-teto',
    },
    {
      type: 'hsp-quiz',
      image: 'assets/icons/content-banner/hsp-quiz.png',
      moveTo: 'hsp',
    },
    {
      type: 'daily-log',
      image: 'assets/icons/content-banner/daily-log.png',
      moveTo: 'daily-log/landing',
    },
    {
      type: 'soulmate',
      image: 'assets/icons/content-banner/soulmate.png',
      moveTo: '',
      onlyForApp: true,
    },
    {
      type: 'situationship-chat-analysis',
      image: 'assets/icons/content-banner/situationship-chat-analysis.png',
      moveTo: 'chat-analysis',
      queryParams: { type: ChatAnalysisType.SITUATIONSHIP },
    },
    {
      type: 'dating-chat-analysis',
      image: 'assets/icons/content-banner/dating-chat-analysis.png',
      moveTo: 'chat-analysis',
      queryParams: { type: ChatAnalysisType.DATING },
    },
    {
      type: 'group-chat-analysis',
      image: 'assets/icons/content-banner/chat-analysis.png',
      moveTo: 'chat-analysis',
      queryParams: { type: ChatAnalysisType.GROUP },
    },
    {
      type: 'mbti-quiz',
      image: 'assets/icons/content-banner/mbti-quiz.png',
      moveTo: 'quiz/create',
    },
    {
      type: 'group-chemi',
      image: 'assets/icons/content-banner/group-chemi.png',
      moveTo: 'group-chemi/create',
    },
    {
      type: 'soulmate',
      image: 'assets/icons/content-banner/soulmate-2.png',
      moveTo: '',
    },
  ]

  private cardListJa: RecommendedContent[] = [
    {
      type: 'saju',
      image: 'assets/icons/content-banner/saju-dohwa-ja.png',
      moveTo: 'saju',
    },
    {
      type: 'hsp-quiz',
      image: 'assets/icons/content-banner/hsp-quiz-ja.png',
      moveTo: 'hsp',
    },
    {
      type: 'soulmate',
      image: 'assets/icons/content-banner/soulmate-ja.png',
      moveTo: '',
      onlyForApp: true,
    },
    {
      type: 'situationship-chat-analysis',
      image: 'assets/icons/content-banner/situationship-chat-analysis-ja.png',
      moveTo: 'chat-analysis',
      queryParams: { type: ChatAnalysisType.SITUATIONSHIP },
      onlyForApp: true,
    },
    {
      type: 'dating-chat-analysis',
      image: 'assets/icons/content-banner/dating-chat-analysis-ja.png',
      moveTo: 'chat-analysis',
      queryParams: { type: ChatAnalysisType.DATING },
      onlyForApp: true,
    },
    {
      type: 'group-chat-analysis',
      image: 'assets/icons/content-banner/chat-analysis-ja.png',
      moveTo: 'chat-analysis',
      queryParams: { type: ChatAnalysisType.GROUP },
      onlyForApp: true,
    },
    {
      type: 'mbti-quiz',
      image: 'assets/icons/content-banner/mbti-quiz-ja.png',
      moveTo: 'quiz/create',
      onlyForApp: true,
    },
    {
      type: 'group-chemi',
      image: 'assets/icons/content-banner/group-chemi-ja.png',
      moveTo: 'group-chemi/create',
      onlyForApp: true,
    },
    {
      type: 'soulmate',
      image: 'assets/icons/content-banner/soulmate-2-ja.png',
      moveTo: '',
      onlyForApp: true,
    },
  ]

  private cardListEn: RecommendedContent[] = [
    {
      type: 'deep-link-cabinet',
      image: 'assets/icons/content-banner/cabinet-en.png',
      moveTo: 'cabinet',
    },
    {
      type: 'deep-link-daily-log',
      image: 'assets/icons/content-banner/daily-log-en.png',
      moveTo: 'gnb/daily-log',
    },
  ]

  cardList: RecommendedContent[] = this.localeService.isKo
    ? this.cardListKo
    : this.localeService.locale === LocaleCode.ja
    ? this.cardListJa
    : this.cardListEn

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.excludedContents.length > 0) {
      this.cardList = this.cardList.filter((card) => !this.excludedContents.includes(card.type))
    }
  }

  async onClickCard(card: RecommendedContent): Promise<void> {
    this.logService.eventLogging(LogEvent.RECOMMENDED_CONTENT_CLICKED, { from: location.pathname, type: card.type })
    if (card.type.includes('deep-link')) {
      return
    }
    if (card.onlyForApp) {
      this.onClickOnlyAppContent(card.type)
      return
    }

    this.onClickWebAppContent(card)
  }

  private async onClickOnlyAppContent(type: RecommendContentType): Promise<void> {
    if (!this.isLoggedIn) {
      this.logService.eventLogging(LogEvent.RECOMMENDED_CONTENT_LOGIN_MODAL_VIEWED, { from: location.pathname, type })
      const loginModal = await this.modalService.openBottomSheet(LoginInstallChoiceModalComponent, {
        title: '먼저 로그인 하고\n결과를 저장하세요',
        description: ' ',
        logOnClickLogin: () => {
          this.logService.eventLogging(LogEvent.RECOMMENDED_CONTENT_LOGIN_MODAL_LOGIN_CLICKED, {
            from: location.pathname,
            type,
          })
        },
        logOnClickInstall: () => {
          this.logService.eventLogging(LogEvent.RECOMMENDED_CONTENT_LOGIN_MODAL_INSTALL_CLICKED, {
            from: location.pathname,
            type,
          })
        },
      })
      await loginModal.present()
      return
    }

    const installModal = await this.modalService.openDialog(AlarmAppInstallModalComponent, {
      title: '앱 전용 기능이에요',
      description: '앱에서 모든 기능을 이용해 보세요',
      buttonText: '타입스 앱 설치하기',
    })
    await installModal.present()
  }

  private async onClickWebAppContent(card: RecommendedContent): Promise<void> {
    this.logService.eventLogging(LogEvent.RECOMMENDED_CONTENT_WEB_MODAL_VIEWED, {
      from: location.pathname,
      type: card.type,
    })
    const appModal = await this.modalService.openBottomSheet(WebInstallChoiceModalComponent, {
      title: '넓은 화면에서 보다 편하게\n이용할 수 있는 타입스 앱이 있어요',
      logOnClickWeb: () => {
        this.logService.eventLogging(LogEvent.RECOMMENDED_CONTENT_WEB_MODAL_WEB_CLICKED, {
          from: location.pathname,
          type: card.type,
        })
      },
      logOnClickInstall: () => {
        this.logService.eventLogging(LogEvent.RECOMMENDED_CONTENT_WEB_MODAL_INSTALL_CLICKED, {
          from: location.pathname,
          type: card.type,
        })
      },
    })
    await appModal.present()

    const { data } = await appModal.onDidDismiss()

    if (data?.type === 'app' && !this.isLoggedIn) {
      this.logService.eventLogging(LogEvent.RECOMMENDED_CONTENT_LOGIN_MODAL_VIEWED, { from: location.pathname })
      const loginModal = await this.modalService.openBottomSheet(LoginInstallChoiceModalComponent, {
        title: '먼저 로그인 하고\n결과를 저장하세요',
        description: ' ',
        logOnClickLogin: () => {
          this.logService.eventLogging(LogEvent.RECOMMENDED_CONTENT_LOGIN_MODAL_LOGIN_CLICKED, {
            from: location.pathname,
            type: card.type,
          })
        },
        logOnClickInstall: () => {
          this.logService.eventLogging(LogEvent.RECOMMENDED_CONTENT_LOGIN_MODAL_INSTALL_CLICKED, {
            from: location.pathname,
            type: card.type,
          })
        },
      })
      await loginModal.present()
    }
    if (data?.type === 'web') {
      this.routerService.navigate(card.moveTo, { queryParams: card.queryParams })
    }
  }

  onClickOpenApp(): void {
    this.logService.eventLogging(LogEvent.RECOMMENDED_CONTENT_HOME_BUTTON_CLICKED, { from: location.pathname })
  }
}
